import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { setLoginInfo } from "redux/Actions";
import { queryClient } from "services/queries";
import { ILoginData } from "types/Login";
import { postLoginGuest } from "../requests/Login";

export function useMutationLoginGuest() {

    const dispatch = useDispatch();

    const query = useMutation(postLoginGuest, {
        onSuccess: (data) => {
            if(data?.success) {
                let loginInfo: ILoginData = data?.data;
                localStorage.setItem('loginInfo', JSON.stringify(loginInfo))
                localStorage.setItem('tokenKey', data?.data?.currentSessionInfo?.access_token);
                queryClient.invalidateQueries('apiProducts')
                dispatch(setLoginInfo(loginInfo));
            } else {
                // console.log(data?.errors)
            }
        }, onError: (data) => {
            // console.error(data)
        }
    });
    return query;
}
